/* ============================================================
   REFORGE DESIGN — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Mobile nav ── */
  function initMobileNav() {
    const btn = document.getElementById('mobile-menu-btn');
    const nav = document.getElementById('mobile-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* ── Active nav ── */
  function initActiveNav() {
    const path = window.location.pathname;
    document.querySelectorAll('[data-nav-link]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      if (href === '/' ? path === '/' : path.startsWith(href)) {
        link.classList.add('active');
      }
    });
  }

  /* ── Image gallery ── */
  function initProductGallery() {
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const mainImg = document.getElementById('main-product-image');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        const srcset = thumb.getAttribute('data-srcset');
        if (src) mainImg.setAttribute('src', src);
        if (srcset) mainImg.setAttribute('srcset', srcset);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ── Variant selection ── */
  function initVariantSelector() {
    const variantSelect = document.getElementById('variant-select');
    if (!variantSelect) return;

    variantSelect.addEventListener('change', () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const price = selectedOption.getAttribute('data-price');
      const available = selectedOption.getAttribute('data-available') === 'true';
      const priceEl = document.getElementById('product-price');
      const addToCartBtn = document.getElementById('add-to-cart-btn');

      if (priceEl && price) priceEl.textContent = price;
      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        addToCartBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  }

  /* ── Add to cart ── */
  function initAddToCart() {
    const form = document.getElementById('add-to-cart-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = form.querySelector('[name="quantity"]')?.value || 1;

      if (!variantId) return;

      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: Number(qty) }),
        });

        if (res.ok) {
          btn.textContent = 'Added!';
          await updateCartCount();
          openCart();
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 2000);
        } else {
          throw new Error('Failed');
        }
      } catch {
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Something went wrong. Please try again.');
      }
    });
  }

  /* ── Cart count ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch {}
  }

  /* ── Cart drawer ── */
  function initCartDrawer() {
    const drawerBtns = document.querySelectorAll('[data-cart-open]');
    const overlay = document.getElementById('cart-overlay');
    const drawer = document.getElementById('cart-drawer');
    const closeBtn = document.getElementById('cart-close');

    if (!overlay || !drawer) return;

    function openCartDrawer() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      fetchCartItems();
    }

    function closeCartDrawer() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }

    drawerBtns.forEach(btn => btn.addEventListener('click', openCartDrawer));
    overlay.addEventListener('click', closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

    window.openCart = openCartDrawer;
    window.closeCart = closeCartDrawer;
  }

  async function fetchCartItems() {
    const itemsEl = document.getElementById('cart-items');
    const subtotalEl = document.getElementById('cart-subtotal');
    if (!itemsEl) return;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (cart.items.length === 0) {
        itemsEl.innerHTML = `
          <div class="cart-drawer__empty">
            <div class="cart-drawer__empty-icon">🛒</div>
            <p>Your cart is empty</p>
          </div>`;
        if (subtotalEl) subtotalEl.textContent = formatMoney(0);
        return;
      }

      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__img" src="${item.featured_image?.url || ''}" alt="${item.product_title}">
          <div class="cart-item__info">
            <div class="cart-item__title">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item__qty">
              <button type="button" onclick="updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
              <span>${item.quantity}</span>
              <button type="button" onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>
      `).join('');

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    } catch {}
  }

  window.updateCartItem = async function (key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      await updateCartCount();
      fetchCartItems();
    } catch {}
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Collection filtering ── */
  function initCollectionFilter() {
    const filterBtns = document.querySelectorAll('[data-filter]');
    const products = document.querySelectorAll('[data-product-type]');
    if (!filterBtns.length) return;

    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const filter = btn.getAttribute('data-filter');
        products.forEach(card => {
          const type = card.getAttribute('data-product-type') || '';
          const show = filter === 'all' || type.toLowerCase().includes(filter.toLowerCase());
          card.style.display = show ? '' : 'none';
        });
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    initMobileNav();
    initActiveNav();
    initProductGallery();
    initVariantSelector();
    initAddToCart();
    initCartDrawer();
    initCollectionFilter();
    updateCartCount();
  });
})();
